(function(){
"use strict";
if (window.__sbInit) return; window.__sbInit = 1;
var SET_HANDLES = window.SB_SET_HANDLES || [];
function currentHandle(){ var m=(location.pathname||'').match(/\/products\/([^\/?#]+)/); return m?decodeURIComponent(m[1]):''; }
if (SET_HANDLES.indexOf(currentHandle()) < 0) return;

var MAXSLOTS = 12;
var priceRoot = document.getElementById('sb-price');
var build = document.getElementById('sb-build');
var config = document.getElementById('sb-config');
var foot = document.getElementById('sb-foot');
var info = document.querySelector('.product__info-container');
if (!priceRoot || !build || !info) return;

var PROD=null, OPT={names:[],values:[]}, NOPT=0, VMAP={}, slots=[], lastN=0, MEDIA_FIRST=null, userTouched=false, SINGLE=false;

function eur(c){ return '€ ' + (c/100).toLocaleString('de-DE',{minimumFractionDigits:2,maximumFractionDigits:2}); }
function qtyInput(){ return document.querySelector('.product__info-container input[name="quantity"]') || document.querySelector('input[name="quantity"]'); }
function getN(){ var q=qtyInput(); var n=q?parseInt(q.value,10):1; if(!n||n<1)n=1; if(n>MAXSLOTS)n=MAXSLOTS; return n; }
function discountRate(n){ return n>=4?0.20:(n>=2?0.10:0); }
function keyOf(arr){ return arr.join('\u0001'); }
function variantForSel(sel){ return VMAP[keyOf(sel)] || null; }
function firstAvailable(){ for(var i=0;i<PROD.variants.length;i++){ if(PROD.variants[i].available) return PROD.variants[i]; } return PROD.variants[0]; }
function escapeHtml(s){ return String(s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
function defaultSel(){ return firstAvailable().options.slice(0,NOPT); }
function ensureSlots(n){ var d=defaultSel(); while(slots.length<n) slots.push({sel:d.slice()}); if(slots.length>n) slots.length=n; }
function slotVariant(i){ return slots[i]?variantForSel(slots[i].sel):null; }
function allValid(){ for(var i=0;i<slots.length;i++){ var v=slotVariant(i); if(!v||!v.available) return false; } return true; }

/* Welche Werte von Option k sind verfuegbar, gegeben die anderen Auswahlen in sel */
function availFor(k, sel){
  var s={};
  for(var i=0;i<PROD.variants.length;i++){ var v=PROD.variants[i]; if(!v.available) continue;
    var ok=true; for(var j=0;j<NOPT;j++){ if(j!==k && v.options[j]!==sel[j]){ ok=false; break; } }
    if(ok) s[v.options[k]]=true;
  }
  return s;
}
/* Nach einer Aenderung an Option changedK die anderen Optionen auf verfuegbare Werte nachziehen */
function reconcile(sel, changedK){
  for(var pass=0; pass<=NOPT; pass++){ var changed=false;
    for(var k=0;k<NOPT;k++){ if(k===changedK) continue;
      var av=availFor(k, sel);
      if(!av[sel[k]]){ for(var vi=0;vi<OPT.values[k].length;vi++){ if(av[OPT.values[k][vi]]){ sel[k]=OPT.values[k][vi]; changed=true; break; } } }
    }
    if(!changed) break;
  }
  return sel;
}

function labelFor(name){
  var n=String(name);
  if (/weinglasgr/i.test(n)) return 'Größe';
  if (/buddy/i.test(n)) return 'Glashülle';
  if (/strap|kette/i.test(n)) return 'Strap';
  return n.replace(/\s*\(Farbe\)\s*/i,'');
}
function isColorOpt(name){ var n=String(name); if(/weinglasgr|größe/i.test(n)) return false; return /farbe|buddy|strap|kette/i.test(n); }

/* Farb-/Bild-Swatch aus den bevin-Daten */
function bgFor(v){
  var IMAGES = window.BEVIN_IMAGES||{}, COLORS = window.BEVIN_COLORS||{};
  var lv=(v||'').toLowerCase();
  for (var k in IMAGES){ if(IMAGES[k] && lv.indexOf(k.toLowerCase())>-1) return "url('"+IMAGES[k]+"')"; }
  if (COLORS[v]) return COLORS[v];
  for (var c in COLORS){ if(c.toLowerCase()===lv) return COLORS[c]; }
  return '#cfcfcf';
}

/* Grosse Galerie umschalten (Dawn media-gallery) */
function mgEl(){ return document.querySelector('media-gallery'); }
function sectionId(){ var li=document.querySelector('media-gallery [data-media-id]'); return li ? (li.getAttribute('data-media-id')||'').replace(/-\d+$/,'') : null; }
function setMedia(mediaId){ var mg=mgEl(); if(!mg||typeof mg.setActiveMedia!=='function'||!mediaId) return; var sid=sectionId(); if(!sid) return; try{ mg.setActiveMedia(sid+'-'+mediaId, false); }catch(e){} }
function setMediaForVariant(v){ if(v && v.featured_media && v.featured_media.id){ userTouched=true; setMedia(v.featured_media.id); } }

function updatePrice(){
  var n=slots.length; var sum=0; for(var i=0;i<n;i++){ var v=slotVariant(i); sum += v?v.price:0; }
  var rate=discountRate(n), now=Math.round(sum*(1-rate)), saved=sum-now;
  var html='<span class="sb-p-now">'+eur(now)+'</span>';
  if (saved>0){ html+='<span class="sb-p-was">'+eur(sum)+'</span><span class="sb-p-save">Du sparst '+eur(saved)+'</span>'; }
  priceRoot.innerHTML=html; priceRoot.hidden=false;
  var cta=foot.querySelector('[data-cta]'); if(cta) cta.disabled=!allValid();
}

function slotHtml(idx){
  var h='<div class="sb-slot" data-slot="'+idx+'"><span class="sb-thumb" data-thumb></span><span class="sb-fields">'
    + '<span class="sb-slot-title">Set '+(idx+1)+'</span>';
  if (!SINGLE){
    for (var k=0;k<NOPT;k++){
      h += '<div class="sb-opt"><label class="sb-flabel">'+escapeHtml(labelFor(OPT.names[k]))+'<span class="sb-fval" data-fval="'+k+'"></span></label><div class="sb-sw-row'+(isColorOpt(OPT.names[k])?'':' sb-chip-row')+'" data-opt="'+k+'"></div></div>';
    }
  }
  h += '<span class="sb-soldout" data-soldout hidden>Diese Kombination ist leider ausverkauft.</span>'
    + '</span></div>';
  return h;
}
function swatchHtml(k, v, sel, off){
  return '<button type="button" class="sb-sw'+(v===sel?' is-sel':'')+(off?' is-off':'')+'" data-opt="'+k+'" data-val="'+escapeHtml(v)+'" title="'+escapeHtml(v)+(off?' (ausverkauft)':'')+'"'+(off?' disabled':'')+' style="background:'+bgFor(v)+';background-size:cover;background-position:center;"></button>';
}
function chipHtml(k, v, sel, off){
  return '<button type="button" class="sb-chip'+(v===sel?' is-sel':'')+(off?' is-off':'')+'" data-opt="'+k+'" data-val="'+escapeHtml(v)+'"'+(off?' disabled':'')+'>'+escapeHtml(v)+'</button>';
}
function paintSlot(idx){
  var w=config.querySelector('[data-slot="'+idx+'"]'); if(!w||SINGLE) return;
  var sel=slots[idx].sel;
  for (var k=0;k<NOPT;k++){
    var row=w.querySelector('.sb-sw-row[data-opt="'+k+'"]'); if(!row) continue;
    var av=availFor(k, sel), color=isColorOpt(OPT.names[k]), h='';
    for (var vi=0;vi<OPT.values[k].length;vi++){ var val=OPT.values[k][vi]; var off=!av[val]; h += color?swatchHtml(k,val,sel[k],off):chipHtml(k,val,sel[k],off); }
    row.innerHTML=h;
    var fv=w.querySelector('[data-fval="'+k+'"]'); if(fv) fv.textContent=': '+sel[k];
  }
}
function updateSlot(idx){
  var w=config.querySelector('[data-slot="'+idx+'"]'); if(!w) return; var v=slotVariant(idx);
  var thumb=w.querySelector('[data-thumb]'), so=w.querySelector('[data-soldout]');
  if (v && v.featured_image && v.featured_image.src) thumb.style.backgroundImage="url('"+v.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i,'_90x$1$2')+"')"; else thumb.style.backgroundImage='none';
  so.hidden = !!(v && v.available);
}
function wireSlot(idx){
  paintSlot(idx); updateSlot(idx);
  var w=config.querySelector('[data-slot="'+idx+'"]'); if(!w||SINGLE) return;
  w.addEventListener('click', function(e){
    var b=e.target && e.target.closest ? e.target.closest('.sb-sw,.sb-chip') : null; if(!b || b.disabled) return;
    var k=parseInt(b.getAttribute('data-opt'),10), val=b.getAttribute('data-val');
    slots[idx].sel[k]=val; reconcile(slots[idx].sel, k);
    paintSlot(idx); updateSlot(idx); updatePrice(); setMediaForVariant(slotVariant(idx));
  });
}
function renderConfig(){
  var n=getN(); ensureSlots(n); lastN=n;
  var stripOnly = (NOPT===1 && /strap|kette/i.test(OPT.names[0]||''));
  var html = '<div class="sb-headline">'+(stripOnly?'Wähle deine Strap/Kette aus':(n===1?'Wunsch-Set zusammenstellen':'Wunsch-Sets zusammenstellen'))+'</div>';
  html += '<div class="sb-slots">';
  for (var i=0;i<n;i++){ html += slotHtml(i); }
  html += '</div>';
  config.innerHTML=html;
  for (var j=0;j<n;j++){ wireSlot(j); }
}

function buildFoot(){
  foot.innerHTML='<button type="button" class="sb-cta" data-cta>In den Warenkorb</button>';
  foot.querySelector('[data-cta]').addEventListener('click', addToCart);
}
function addToCart(){
  if (!allValid()) return;
  var cta=foot.querySelector('[data-cta]'); var old=cta.textContent;
  cta.disabled=true; cta.textContent='Wird hinzugefügt …';
  var items=slots.map(function(sl){ var v=variantForSel(sl.sel); return {id:v.id,quantity:1}; });
  var drawer=document.querySelector('cart-drawer');
  var useDrawer=drawer && typeof drawer.renderContents==='function' && typeof drawer.getSectionsToRender==='function';
  var payload={items:items};
  if (useDrawer){ payload.sections=drawer.getSectionsToRender().map(function(s){return s.id;}); payload.sections_url=location.pathname; }
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)})
    .then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); })
    .then(function(res){
      cta.disabled=false; cta.textContent=old;
      if (useDrawer){
        try { if(drawer.classList) drawer.classList.remove('is-empty'); drawer.renderContents(res); } catch(e){ location.href='/cart'; return; }
        try { if(typeof drawer.open==='function' && !document.body.classList.contains('js-drawer-open')) drawer.open(); } catch(e){}
        if (typeof window.onvolumechange==='function'){ try { window.onvolumechange(); } catch(e){} }
      } else location.href='/cart';
    })
    .catch(function(){ cta.disabled=false; cta.textContent=old; alert('Leider konnte nicht in den Warenkorb gelegt werden. Bitte erneut versuchen.'); });
}
function maybeRerender(){ var n=getN(); if (n!==lastN){ ensureSlots(n); renderConfig(); updatePrice(); lastN=n; } }
function arrange(){
  var np = info.querySelector('.price');
  if (np && np.previousElementSibling !== priceRoot){ np.parentNode.insertBefore(priceRoot, np); }
  var q = info.querySelector('.product-form__quantity');
  if (q && q.nextElementSibling !== build){ q.parentNode.insertBefore(build, q.nextSibling); }
  else if (!q){ var mk=info.querySelector('.mk-wrap'); if (mk && mk.nextElementSibling !== build){ mk.parentNode.insertBefore(build, mk.nextSibling); } }
  var del = document.querySelector('.stock-text__wrapper');
  if (del && del.parentNode !== foot){ foot.insertBefore(del, foot.firstChild); }
}

function init(p){
  PROD=p; OPT.names=p.options.map(function(o){return o.name;}); OPT.values=p.options.map(function(o){return o.values;}); NOPT=OPT.names.length;
  for (var i=0;i<p.variants.length;i++){ var v=p.variants[i]; VMAP[keyOf(v.options.slice(0,NOPT))]=v; }
  SINGLE = (NOPT===1 && OPT.values[0].length<=1);
  MEDIA_FIRST = (p.media && p.media.length) ? p.media[0].id : null;
  info.classList.add('sb-active'); document.documentElement.classList.add('sb-on');
  ensureSlots(getN()); lastN=getN();
  buildFoot(); renderConfig(); updatePrice();
  build.hidden=false; priceRoot.hidden=false;
  arrange();
  /* Standardbild = 1. Produktbild (nicht die vorausgewaehlte Variante) */
  setMedia(MEDIA_FIRST);
  setTimeout(function(){ if(!userTouched) setMedia(MEDIA_FIRST); }, 700);
  setTimeout(function(){ if(!userTouched) setMedia(MEDIA_FIRST); }, 1600);
  document.addEventListener('click', function(e){
    if (e.target && e.target.closest && e.target.closest('.mk-tile')){ setTimeout(function(){ ensureSlots(getN()); renderConfig(); updatePrice(); lastN=getN(); }, 40); }
  }, true);
  var q=qtyInput(); if(q){ ['input','change'].forEach(function(ev){ q.addEventListener(ev, maybeRerender); }); }
  setInterval(function(){ arrange(); maybeRerender(); }, 600);
}
function fail(){ /* Prehide loesen, nativ bleibt bedienbar */ var ph=document.getElementById('sb-prehide'); if(ph) ph.parentNode.removeChild(ph); }
/* Sofort aus serverseitig inlinten Daten rendern (kein Netzwerk-Warten); sonst Fetch-Fallback */
if (window.SB_PRODUCT && window.SB_PRODUCT.variants && window.SB_PRODUCT.variants.length){
  try { init(window.SB_PRODUCT); }
  catch(e){ fetch('/products/'+currentHandle()+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(init).catch(fail); }
} else {
  fetch('/products/'+currentHandle()+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(init).catch(fail);
}
})();
